import { render, staticRenderFns } from "./company-brand-image-modal.vue?vue&type=template&id=406c60d0"
import script from "./company-brand-image-modal.vue?vue&type=script&lang=js"
export * from "./company-brand-image-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports